import { useMutation, useQuery } from '@tanstack/react-query';

import {
  BusinessEntitySimilarRequest,
  contractsRefresh,
  getSimilarBusinessEntityList,
} from '~apis/business-entity';
import { getBusinessEntityDetail } from '~apis/contract';
import { queryClient } from '~libs/queryClient';

import { ContractQueryKey } from '../contract/query';

const BUSINESS_ENTIY_QUERY_KEY = {
  default: ['businessEntity'],
  detail: (companyId: string, businessEntityId: number) => [
    'businessEntity',
    companyId,
    businessEntityId,
  ],
  getSimilarBusinessEntities: (params: BusinessEntitySimilarRequest) => [
    'businessEntity',
    'similar',
    params.companyId,
    params.query,
  ],
};

export function useGetSimilarBusinessEntities(params: BusinessEntitySimilarRequest) {
  return useQuery({
    queryKey: BUSINESS_ENTIY_QUERY_KEY.getSimilarBusinessEntities(params),
    queryFn: () => getSimilarBusinessEntityList(params),
    enabled: !!params.companyId,
  });
}

export function useGetBusinessEntityDetail(companyId: string, id: number) {
  return useQuery({
    queryKey: BUSINESS_ENTIY_QUERY_KEY.detail(companyId, id),
    queryFn: () => getBusinessEntityDetail({ companyId, id }),
    enabled: !!companyId && !!id,
  });
}

export function useRefreshContracts() {
  return useMutation({
    mutationFn: (companyId: string) => contractsRefresh({ companyId }),
    onSuccess: (_, companyId) => {
      queryClient.invalidateQueries(ContractQueryKey.list({ companyId: companyId }));
    },
  });
}
